import { useCallback, useRef, useState } from "react";
import { message } from "antd";
import { hasRealQuestions } from "../utils";

export function useEvaluationDetail({ accessToken, evalApi }) {
  const [selected, setSelected] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);

  // evita race conditions al abrir/cerrar rápido
  const detailReqIdRef = useRef(0);

  const openDetail = useCallback(
    async (ev) => {
      if (!ev) return;

      // abre inmediatamente con snapshot
      setSelected(ev);
      setDetailOpen(true);

      if (!accessToken || !ev._id) return;

      // si ya trae preguntas reales, no refetch
      if (hasRealQuestions(ev)) {
        setDetailLoading(false);
        return;
      }

      const reqId = ++detailReqIdRef.current;
      setDetailLoading(true);

      try {
        const full = await evalApi.getEvaluationById(accessToken, ev._id);
        if (reqId !== detailReqIdRef.current) return;
        setSelected(full);
      } catch (e) {
        if (reqId !== detailReqIdRef.current) return;
        console.error(e);
        message.error(e?.message || "No se pudo cargar el detalle");
      } finally {
        if (reqId === detailReqIdRef.current) setDetailLoading(false);
      }
    },
    [accessToken, evalApi],
  );

  const closeDetail = useCallback(() => {
    detailReqIdRef.current += 1;
    setDetailLoading(false);
    setDetailOpen(false);
    setSelected(null);
  }, []);

  return {
    selected,
    setSelected, // compat por si lo usas en algún sitio
    detailOpen,
    detailLoading,
    openDetail,
    closeDetail,
  };
}
